/** @returns {Record<string, string>} */
export const getScheduleFilterAnalyticsParams = (filter) => {
  let searchSource = "program_page";
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    if (params.get("source") === "home_finder") {
      searchSource = "home_finder";
    }
  }

  return {
    filter_days: (filter?.days || []).join(",") || "none",
    filter_time: filter?.timeOfDay || "any",
    filter_age_years:
      filter?.childAgeYears === null || filter?.childAgeYears === undefined
        ? "any"
        : String(filter.childAgeYears),
    filter_age_months: String(filter?.childAgeMonths ?? 0),
    filter_open_spots_only: filter?.openSpotsOnly ? "true" : "false",
    search_source: searchSource,
  };
};

/** Encodes age, days, time, etc. into GA4 label (already a registered dimension). */
export const buildEmptySearchLabel = (filter, emptyReason, searchSource) => {
  const params = getScheduleFilterAnalyticsParams(filter);
  const source = searchSource || params.search_source || "program_page";
  const years = filter?.childAgeYears;
  const months = filter?.childAgeMonths ?? 0;
  const age =
    years === null || years === undefined || years === ""
      ? "any"
      : `${years}_${months}`;
  const days = (filter?.days || []).length ? filter.days.join(",") : "none";
  const time = filter?.timeOfDay || "any";
  const open = filter?.openSpotsOnly ? "1" : "0";
  const reason =
    typeof emptyReason === "object" && emptyReason !== null
      ? emptyReason.type || "unknown"
      : emptyReason || "unknown";

  return `a${age}|d${days}|t${time}|o${open}|r${reason}|s${source}`;
};
